import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

const Login = () => import(/* webpackChunkName: "login" */ "@/views/Login");
const Cadastro = () =>
  import(/* webpackChunkName: "cadastro" */ "@/views/Cadastro");
const AlterarSenha = () =>
  import(/* webpackChunkName: "alterarSenha" */ "@/views/AlterarSenha");
const Clientes = () =>
  import(/* webpackChunkName: "clientes" */ "@/views/Clientes");
const PontosPesquisa = () =>
  import(/* webpackChunkName: "pontosPesquisa" */ "@/views/PontosPesquisa");
const PesquisaDetalhes = () =>
  import(/* webpackChunkName: "pesquisaDados" */ "@/views/PesquisaDetalhes");
const PesquisaTempoReal = () =>
  import(
    /* webpackChunkName: "pesquisaTempoReal" */ "@/views/PesquisaTempoReal"
  );
const CompartilharResultados = () =>
  import(
    /* webpackChunkName: "compartilharResultados" */ "@/views/CompartilharResultados"
  );
const Usuarios = () =>
  import(/* webpackChunkName: "usuarios" */ "@/views/Usuarios");
const Empresas = () =>
  import(/* webpackChunkName: "empresas" */ "@/views/Empresas");
const Arquivadas = () =>
  import(/* webpackChunkName: "arquivadas" */ "@/views/Arquivadas");
const ResetarSenha = () =>
  import(/* webpackChunkName: "resetarSenha" */ "@/views/ResetarSenha");
const ResponderPesquisa = () =>
  import(
    /* webpackChunkName: "responderPesquisa" */ "@/views/ResponderPesquisa"
  );
const Error404 = () =>
  import(/* webpackChunkName: "error404" */ "@/views/errors/Error404");

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/app/",
  routes: [
    { path: "/", redirect: { name: "login" } },
    { path: "/equiz", redirect: { name: "login" } },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { title: "Login", requiresAuth: false },
    },
    {
      path: "/cadastro",
      name: "cadastro",
      component: Cadastro,
      meta: { title: "Cadastro", requiresAuth: false },
    },
    {
      path: "/alterarSenha",
      name: "alterarSenha",
      component: AlterarSenha,
      meta: { title: "Alterar Senha", requiresAuth: true },
    },
    {
      path: "/clientes",
      name: "clientes",
      component: Clientes,
      meta: { title: "Clientes", requiresAuth: true },
    },
    {
      path: "/pontosPesquisa/:idfilial?",
      name: "pontosPesquisa",
      component: PontosPesquisa,
      meta: { title: "Pontos de Pesquisa", requiresAuth: true },
    },
    {
      path: "/pontosPesquisa/dashboard/:id",
      name: "pesquisaDetalhes",
      component: PesquisaDetalhes,
      meta: { title: "Detalhes da Pesquisa", requiresAuth: true },
    },
    {
      path: "/pontosPesquisa/acompanharPesquisa/:id",
      name: "acompanharPesquisa",
      component: PesquisaTempoReal,
      meta: { title: "Acompanhar Pesquisa", requiresAuth: true },
    },
    {
      path: "/pontosPesquisa/compartilharResultados/:linkurl",
      name: "compartilharResultados",
      component: CompartilharResultados,
      meta: { title: "Compartilhar Resultados", requiresAuth: false },
    },
    {
      path: "/usuarios",
      name: "usuarios",
      component: Usuarios,
      meta: { title: "Usuarios", requiresAuth: true, adminOnly: true },
    },
    {
      path: "/empresa",
      name: "empresa",
      component: Empresas,
      meta: {
        title: "Empresas",
        requiresAuth: true,
        adminOnly: true,
        noDateLimitAccess: true,
      },
    },
    {
      path: "/arquivadas",
      name: "arquivadas",
      component: Arquivadas,
      meta: {
        title: "Pesquisas Arquivadas",
        requiresAuth: true,
        adminOnly: true,
      },
    },
    {
      path: "/resetarSenha",
      name: "resetarSenha",
      component: ResetarSenha,
      meta: {
        title: "Resetar Senha",
        requiresAuth: false,
        adminOnly: false,
      },
    },
    {
      path: "/responderPesquisa/:linkurl",
      name: "responderPesquisa",
      component: ResponderPesquisa,
      meta: { title: "Responder Pesquisa", requiresAuth: false },
    },
    {
      path: "*",
      component: Error404,
      meta: { title: "Página não encontrada!", requiresAuth: false },
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.dispatch("autoLogin");
  if (to.meta.requiresAuth) {
    if (!store.getters.isAuthenticated) {
      next({ name: "login" });
      return;
    } else if (
      /* - Retirei para não ter opção de bloqueio porque é gratuito
    if (store.getters.isAccessExpired && to.name != "empresa") {
      next({ name: "empresa" });
      return;
    } 
    */
      // !store.getters.isAccessExpired &&
      store.getters.user &&
      store.getters.user.flgperfil != "G" &&
      to.meta.adminOnly
    ) {
      next({ name: "pontosPesquisa" });
      return;
    }
  } else if (store.getters.isAuthenticated) {
    if (to.name != "responderPesquisa" && to.name != "compartilharResultados") {
      if (from.name != null) next(from);
      else next({ name: "clientes" });
    }
  }
  next();
});

router.afterEach((to) => {
  if (to.meta.title) document.title = to.meta.title;
});

export default router;
